"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Unity = exports.ModalVideo = exports.Modal = exports.Alert = exports.Accordion = exports.Upload = exports.Table = exports.Popover = exports.BannerVideo = exports.Carousel = exports.SidebarNav = exports.Utils = exports.Forms = exports.Base = void 0;
var base_1 = require("./base");
exports.Base = base_1.default;
var forms_1 = require("./forms");
exports.Forms = forms_1.default;
var utils_1 = require("./utils");
exports.Utils = utils_1.default;
var sidebar_nav_1 = require("./components/sidebar-nav");
exports.SidebarNav = sidebar_nav_1.default;
var carousel_1 = require("./components/carousel");
exports.Carousel = carousel_1.default;
var banner_video_1 = require("./components/banner-video");
exports.BannerVideo = banner_video_1.default;
var video_1 = require("./components/video");
var popover_1 = require("./components/popover");
exports.Popover = popover_1.default;
var table_1 = require("./components/table");
exports.Table = table_1.default;
var upload_1 = require("./common/upload");
exports.Upload = upload_1.default;
var accordion_1 = require("./components/accordion");
exports.Accordion = accordion_1.default;
var alert_1 = require("./components/alert");
exports.Alert = alert_1.default;
var modal_1 = require("./components/modal");
exports.Modal = modal_1.default;
var modal_video_1 = require("./components/modal-video");
exports.ModalVideo = modal_video_1.default;
var teaser_1 = require("./components/teaser");
var tabs_1 = require("./components/tabs");
var pagination_1 = require("./components/pagination");
var Unity = /** @class */ (function () {
    function Unity(documentObject) {
        this.base = new base_1.default(documentObject);
        this.forms = new forms_1.default(documentObject);
        this.utils = new utils_1.default();
        this.sidebarNav = new sidebar_nav_1.default(documentObject);
        this.carousel = new carousel_1.default(documentObject);
        this.bannerVideo = new banner_video_1.default(documentObject);
        this.video = new video_1.default(documentObject);
        this.popover = new popover_1.default(documentObject, null, null);
        this.table = new table_1.default(documentObject);
        this.upload = new upload_1.default(documentObject);
        this.accordion = new accordion_1.default(documentObject);
        this.alert = new alert_1.default(documentObject);
        this.modal = new modal_1.default(documentObject);
        this.modalVideo = new modal_video_1.default(documentObject);
        this.teaser = new teaser_1.default(documentObject);
        this.tabs = new tabs_1.default(documentObject);
        this.pagination = new pagination_1.default(documentObject);
    }
    return Unity;
}());
exports.Unity = Unity;
exports.default = Unity;
